import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../base/base.component';
import { MemberOrganizationInfoModel } from '../../models/member-organization-info.model';
import { DataService } from '../../services/data.service';
import { LayoutService } from '../../services/layout.service';
import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign';

declare let gigya: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent extends BaseComponent implements OnInit, AfterViewInit {
  @ViewChild('profileSettingsPopover') profileSettingsPopover: ElementRef;
  memberOrganizationInfo: MemberOrganizationInfoModel;

  constructor(
    private dataService: DataService,
    private router: Router,
    private layoutService: LayoutService
  ) {
    super();
  }

  ngOnInit() {
    this.dataService.selectedMemberInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
      this.memberOrganizationInfo = value;
    });
  }

  ngAfterViewInit() {
    const interval = setInterval(() => {
      const shellbar = document.querySelector('ui5-shellbar');
      if (shellbar && shellbar.shadowRoot) {
        const element = shellbar.shadowRoot.querySelector('.ui5-shellbar-image-button') as HTMLElement;
      
        if (element) {
          element.style.pointerEvents = "none";
          clearInterval(interval); // Stop checking once applied
        }

        //const buttons= shellbar.shadowRoot.querySelectorAll('ui5-button') as NodeListOf<HTMLElement>;
        const buttons = Array.from(shellbar.shadowRoot.querySelectorAll('ui5-button')) as HTMLElement[];
        buttons.forEach(button => {
          if(button.getAttribute("icon")=="log"){
            //button log out
            button.style.position="absolute";
            button.style.top="10px";
            button.style.right="40px";
          }

          if(button.getAttribute("icon")=="sap-icon://overflow"){
            button.setAttribute("icon", "log");
            button.style.position="absolute";
            button.style.top="10px";
            button.style.right="25px";
          }
        })
      }
    }, 0); 
  }

  handleProfileClick(event: any) {
    this.profileSettingsPopover.nativeElement.showAt(event.detail.targetRef);
  }

  handleSignOut() {
    gigya.accounts.logout({});
    this.router.navigate(['/login']);
  }

  handleLogoClick() {
    this.router.navigate(['/settings']);
  }

  handleHamburgerClick() {
    this.layoutService.openNavigationDrawer();
  }
}
